import { InjectionToken } from '@angular/core';
import { Balance } from 'mbs-ui-shared@components/components/models/license.model';

export const BALANCE_TOKEN = new InjectionToken<Balance>('BALANCE_TOKEN');
